import { render, staticRenderFns } from "./ImportsPagesContainer.vue?vue&type=template&id=ea1f1b92&"
import script from "./ImportsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./ImportsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports